/*
subNavigation

if sub-navigation is to long it shows button (…) to expand sub-navigation on second line

tobias.wolf@wagnerwagner.de
*/


(function () {
  // elements
  const element = document.querySelector('.sub-navigation');
  let ulElement;
  let lastLiElement;
  const buttonElement = document.createElement('button');
  let marginBottom = 0; // 8 = margin-bottom of .header
  if (element) {
    ulElement = element.querySelector('ul');
    lastLiElement = ulElement.querySelector('li:last-of-type');
  }
  if (window.matchMedia('(min-width: 58em)').matches) {
    marginBottom = 8;
  }

  // functions
  function init() {
    if (!isTouchDevice()
        && ulElement.scrollWidth > ulElement.clientWidth
        && window.matchMedia('(min-width: 15em)').matches) {
      element.insertBefore(buttonElement, ulElement);
      element.classList.add('sub-navigation_may-extend');
      buttonElement.classList.add('sub-navigation__extend-button');
      buttonElement.setAttribute('aria-label', 'Alle Navigationspunkte anzeigen');
      ulElement.style.marginBottom = `${marginBottom * -1}px`;
    }
  }
  function extend() {
    /*
    [1]: 10 = margin-bottom of .header + height of seperation line top (.sub-navigation)
    */
    const height = ulElement.offsetHeight * (lastLiElement.offsetTop / lastLiElement.offsetHeight + 1);
    let _marginBottom = (height - lastLiElement.offsetHeight) * -1 - (marginBottom + 2) * 2; // [1]
    if (!window.matchMedia('(min-width: 58em)').matches) {
      _marginBottom = (height - lastLiElement.offsetHeight) * -1 - 12; // [1]
    }
    ulElement.style.height = `${height}px`;
    ulElement.style.marginBottom = `${_marginBottom}px`;
    element.classList.add('is-extended');
    document.addEventListener('click', handleDocumentClick);
  }
  function contract() {
    const height = lastLiElement.offsetHeight;
    ulElement.style.height = `${height}px`;
    ulElement.style.marginBottom = `${marginBottom * -1}px`;
    element.classList.remove('is-extended');
    document.removeEventListener('click', handleDocumentClick);
  }
  function handleDocumentClick(e) {
    if (getParents(e.target, '.sub-navigation').length === 0) {
      contract();
    }
  }
  function handleButtonClick() {
    if (element.classList.contains('is-extended')) {
      contract();
    } else {
      extend();
    }
  }

  // event listener
  buttonElement.addEventListener('click', handleButtonClick);

  // init
  if (element) {
    // wait for font rendering (ie-fix)
    setTimeout(() => {
      init();
    }, 30);
  }
}());
